<template>
    <div class="flex flex-col min-h-screen">
        <header>
            <slot name="header">
                <Header v-bind="headerProps" />
            </slot>
        </header>

        <main class="flex-1 pt-5 overflow-auto">
            <div :class="`${customContainerClass} mx-auto px-4`">
                <VpnWarningBanner />
                <geo-watcher />
                <ErrorBanner 
                    v-if="$store.getters.generalErrors && Object.keys($store.getters.generalErrors).length > 0"
                    :errors="$store.getters.generalErrors"
                    @dismiss="$store.commit('clearGeneralErrors')"
                />
                <slot />
            </div>
        </main>

        <footer class="flex-shrink-0">
            <slot name="footer">
                <Footer v-bind="footerProps" />
            </slot>
        </footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
import Header from "./Header.vue";
import VpnWarningBanner from "../../../components/VpnWarningBanner.vue";
import GeoWatcher from "../../../components/GeoWatcher.vue";
import ErrorBanner from "../../leadgen/components/ErrorBanner.vue";

export default {
    components: { Footer, Header, VpnWarningBanner, GeoWatcher, ErrorBanner },

    props: {
        headerProps: {
            type: Object,
            default: () => ({})
        },
        footerProps: {
            type: Object,
            default: () => ({})
        },
        customContainerClass: {
            type: String,
            default: 'container'
        }
    },
};
</script>
